import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

/**
 * This button signals to Main that the Domain of the Day
 *  img should be displayed or taken down.
 *
 *  DomainButton is a button with state storing a boolean, clicked.
 *  Clicked status is passed up to parent component(s).
 *
 * @reactProps {function} onClick - a function that takes a boolean argument
 */
export default class DomainButton extends React.Component {
  state = {};

  /**
   * Flip clicked on state, pass clicked to parent
   */
  onClick = () => {
    let clicked = !this.state.clicked;
    this.props.onClick(clicked);
    this.setState({ clicked });
  };

  /**
   * Renders a button styled logically with clicked deconstructed from state
   */
  render() {
    const { clicked } = this.state;
    return (
      <button onClick={this.onClick} className={cx({ clicked }, 'closed-menu')}>
        <div className="title">
          <h3>Domain of the Day</h3>
        </div>
      </button>
    );
  }
}

DomainButton.propTypes = {
  onClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/DomainButton.js